























import {
  Component,
  Prop,
  Mixins,
  Watch,
} from 'vue-property-decorator';
import NormalizerMixin from '@/mixins/NormalizerMixin';

@Component
export default class CustomSelect extends Mixins(NormalizerMixin) {
  @Prop()
  value!: any;

  @Prop()
  label!: string;

  @Prop()
  items!: Array<any>;

  @Prop()
  dense!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  }) readonly outlined!: boolean

  @Prop({
    type: String,
    default: '',
  }) readonly prependIcon!: string

  @Prop({
    default: false,
  })
  alwaysEmit!: boolean;

  @Prop({
    default: null,
  })
  loading!: boolean | null;

  @Prop()
  errorMessages!: Array<string> | string;

  internalValue: any = null;

  get isLoading() {
    if (this.loading === null) {
      return !this.items.length;
    }
    return this.loading;
  }

  beforeMount() {
    this.selectCurrentValueFromItems();
  }

  selectCurrentValueFromItems() {
    if (this.value && this.items?.length) {
      for (let i = 0; i < this.items.length; i += 1) {
        const item = this.items[i];
        if (parseInt(item.id, 10) === parseInt(this.value.id, 10)) {
          this.internalValue = item;
          if (this.alwaysEmit) {
            this.onChange(item);
          }
        }
      }
    } else {
      this.internalValue = null;
    }
  }

  @Watch('items')
  itemsChanged() {
    this.selectCurrentValueFromItems();
  }

  @Watch('value')
  valueChanged() {
    this.selectCurrentValueFromItems();
  }

  onChange(item: any) {
    this.$emit('change', item);
    this.$emit('input', item);
  }
}
